<template>
    <div :class="leftright == 0 ? 'fact colorful' : 'fact'">
        <div v-if="leftright == 0" class="content">
            <div class="span-wrapper"><span :class="icon"/></div>
            <h1>{{headline}}</h1>
            <div class="description">{{desc}}</div>
        </div>
        <div class="mockup">
            <img :src="img"/>
        </div>
        <div v-if="leftright == 1" class="content">
            <div class="span-wrapper"><span :class="icon"/></div>
            <h1>{{headline}}</h1>
            <div class="description">{{desc}}</div>
        </div>
    </div>
</template>


<script>
export default {
  name: "Fact",
  props: ['headline', 'icon','desc','img', 'leftright']
};
</script>

<style lang="scss" scoped>
.fact{
    padding: 5%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &.colorful{
        background-color: rgb(246,249,254);
    }
    .content{
        margin: 10%;
        flex:1;
        @media(max-width: 780px){
            text-align: center;
        }
        @media(min-width: 2000px){
            margin: 2%;
        }
        .span-wrapper{
            margin: 5%;
            span{
                font-size: 3rem;
                color: rgb(100,161,211);
            }
        }
        h1{
            margin: 5%;
            font-size: 3rem;
            font-weight: bold;
        }
        .description{
            margin: 5%;
            color: rgb(107,115,122);
            font-weight: 500;
            font-size:1.1rem;
            line-height: 1.5rem;
            text-align: justify;
        }
    }
    .mockup{
        @media(max-width: 780px){
            display: none;
        }
        flex:1;
        img{
            max-width: 100%;
            @media(min-width: 2000px){
                max-width: 60%;
            }
        }
    }
}
</style>
